import React from 'react'

export default {
    key: 'institution-pharmacy-change-depend-on-status-action',
    order: 2000,
    build(stub) {
        class ChangeStatus extends React.Component{

            handSubmit = (e) => {
                const { model, field: { formatter: { args: { anchor, url } } }, page } = this.props;
                const dataToSubmit = {
                    id: model.id,
                    [anchor]: model[anchor] ? 0 : 1
                }
                e&&e.stopPropagation();
                stub.api.post(url, dataToSubmit).then(res => {
                    model[anchor] = model[anchor] ? 0 : 1
                    page.data = { ...page.data }
                    stub.store.dispatch({type: stub.constant.actionTypes.DUMMY_ACTION})
                })
            };
            render() {
                const { model, field: { formatter: { args: { anchor } } } } = this.props;
                return(
                    <React.Fragment>
                        {/* eslint-disable-next-line no-script-url,jsx-a11y/anchor-is-valid */}
                        {model[anchor] ? <a href="javascript:" onClick={(e) => {
                                e&&e.stopPropagation();
                                this.relieveTips.show()
                            }}>解除挂靠</a> :
                            // eslint-disable-next-line no-script-url,jsx-a11y/anchor-is-valid
                            <a href="javascript:" onClick={(e) => {
                                e&&e.stopPropagation()
                                this.againTips.show()
                            }}>重新挂靠</a>}
                        <stub.ui.Tip
                            key="again"
                            onRef={ref => this.againTips = ref}
                            tips={stub.filter.transform('确定重新挂靠？')}
                            onOk={this.handSubmit}/>
                        <stub.ui.Tip
                            key="relieve"
                            onRef={ref => this.relieveTips = ref}
                            tips={stub.filter.transform('确定解除挂靠？')}
                            onOk={this.handSubmit}/>
                    </React.Fragment>
                )
            }
        }
        return ChangeStatus
    }
}